import { render, staticRenderFns } from "./Communities.view.vue?vue&type=template&id=20fbf45f&"
import script from "./Communities.view.vue?vue&type=script&lang=js&"
export * from "./Communities.view.vue?vue&type=script&lang=js&"
import style0 from "./Communities.view.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Communities.view.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports